import React, { lazy } from 'react';
import { Route } from 'react-router';
import ValidatedRoute from 'chameleon-src/utility/validatedRoute';

const ScoringByRubricContainer = lazy(
  () => import('legacy-src/components/scoring/ScoringByRubricContainer'),
);

const ScoringLayout = lazy(
  () => import('legacy-src/components/scoring/ScoringLayout'),
);

export default (
  <Route
    path="score/:assignmentId/students/:studentId"
    component={ValidatedRoute(ScoringByRubricContainer)}
  >
    <Route
      name="name"
      path="questions/:questionId"
      component={ValidatedRoute(ScoringLayout)}
    />
  </Route>
);
